import React from "react";
import { useAuth } from "../context/AuthContext";
import { IMAGES } from "../mock";
import { User, Car, LogOut } from "lucide-react";
import PassengerApp from "./PassengerApp";
import DriverApp from "./DriverApp";
import { toast } from "sonner";

export default function AppShell() {
  const { user, logout, switchRole } = useAuth();
  const role = user.active_role;

  const change = async (r) => {
    if (r === role) return;
    try { await switchRole(r); toast.success(`Switched to ${r} mode`); }
    catch (e) { toast.error(e?.response?.data?.detail || "Cannot switch role"); }
  };

  return (
    <div className="min-h-screen bg-[#07090a]">
      <header className="sticky top-0 z-40 bg-[#07090a]/90 backdrop-blur-md border-b border-white/10">
        <div className="mx-auto max-w-6xl px-4 sm:px-6 h-16 flex items-center justify-between">
          <a href="/"><img src={IMAGES.logo} alt="InstantDrive" className="h-9" /></a>

          <div className="flex items-center rounded-xl bg-[#0e1311] border border-white/10 p-1">
            {[{ id: "passenger", label: "Passenger", Icon: User }, { id: "driver", label: "Driver", Icon: Car }].map(({ id, label, Icon }) => (
              <button key={id} data-testid={`role-switch-${id}`} onClick={() => change(id)}
                className={`flex items-center gap-1.5 px-3 sm:px-4 py-2 rounded-lg text-sm font-semibold transition-all ${role === id ? "bg-[#2fd645] text-[#06210b]" : "text-white/60 hover:text-white"}`}>
                <Icon className="h-4 w-4" /> <span className="hidden sm:inline">{label}</span>
              </button>
            ))}
          </div>

          <div className="flex items-center gap-3">
            <div className="hidden sm:block text-right">
              <div className="text-sm font-semibold text-white leading-none">{user.name}</div>
              <div className="text-xs text-white/40 capitalize">{role} mode</div>
            </div>
            <button data-testid="logout-button" aria-label="Log out" onClick={logout} className="h-9 w-9 rounded-lg border border-white/10 bg-white/5 flex items-center justify-center text-white/70 hover:text-[#2fd645]">
              <LogOut className="h-4 w-4" />
            </button>
          </div>
        </div>
      </header>

      <main className="mx-auto max-w-6xl px-4 sm:px-6 py-8">
        {role === "driver" ? <DriverApp /> : <PassengerApp />}
      </main>
    </div>
  );
}
